<template>
  <div class="comments-section">
    <div v-if="commentCompetitionEnabled" class="mb-5 ">
      <CommentCompetitionBanner />
    </div>
    <h2 class="d-flex align-items-center mb-4">
      <span class="comment-count">
        <span class="count">{{countTotalItems()}}</span>
        <font-awesome-icon :icon="['far', 'comment-alt']"/>
      </span>
      <span class="text-md ml-3 mb-1" v-html="$t('comments.commentsSectionHeader')"></span>
    </h2>
    <div class="mb-4">
      <CommentFormLoggedIn v-if="loggedIn" :materialId="materialId"/>
      <CommentFormNotLoggedin v-else :materialId="materialId" />
    </div>
    <div v-if="highlightedComments && !isEmptyObject(highlightedComments)" class="highlighted-comments mb-3">
      <div v-for="comment in highlightedComments" :key="comment.id" class="mb-3">
        <CommentItem :comment="comment" :highlighted="true" :commentCompetitionEnabled="commentCompetitionEnabled" />
      </div>
      <div v-if="highlightedCommentsLoadingMore">
        <CommentItemSkeleton />
      </div>
      <div v-if="!highlightedCommentsReachedTheEnd" @click="getHighlightedComments(true)" class="load-more">
        <p><span>{{$t('common.loadMore')}}</span></p>
      </div>
    </div>
    <div>
      <div v-if="postedComments">
        <div v-for="comment in postedComments" :key="comment.id" class="mb-3">
          <CommentItem :comment="comment" :posted="true" />
        </div>
      </div>
      <div v-if="comments">
        <div v-for="comment in comments" :key="comment.id" class="mb-3">
          <CommentItem :comment="comment" />
        </div>
        <div v-if="loadingMore">
          <CommentItemSkeleton />
        </div>
        <div v-if="!reachedTheEnd" @click="getComments(true)" class="load-more">
          <p><span>{{$t('common.loadMore')}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CommentFormLoggedIn from './CommentFormLoggedin.vue';
import CommentFormNotLoggedin from './CommentFormNotLoggedin.vue';
import CommentItem from './CommentItem.vue';
import CommentItemSkeleton from './CommentItemSkeleton.vue';
import CommentCompetitionBanner from './CommentCompetitionBanner.vue';

export default {
  props: {
    materialId: Number || String,
    commentCompetitionEnabled: Boolean,
  },
  components: {
    CommentFormLoggedIn,
    CommentFormNotLoggedin,
    CommentItem,
    CommentItemSkeleton,
    CommentCompetitionBanner,
  },
  computed: {
    ...mapGetters({
      comments: 'comment/comments',
      postedComments: 'comment/postedComments',
      loadingMore: 'comment/loadingMore',
      reachedTheEnd: 'comment/reachedTheEnd',
      totalItems: 'comment/totalItems',
      // Highlighted comments
      highlightedComments: 'comment/highlightedComments',
      highlightedCommentsLoadingMore: 'comment/highlightedCommentsLoadingMore',
      highlightedCommentsReachedTheEnd: 'comment/highlightedCommentsReachedTheEnd',
      highlightedCommentsTotalItems: 'comment/highlightedCommentsTotalItems',
    }),
    loggedIn() {
      return this.$store.state.user.status.loggedIn;
    },
  },
  mounted() {
    this.getComments();
    this.getHighlightedComments();
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'user/loginSuccess') {
        this.getComments();
        this.getHighlightedComments();
      }
    });
  },
  methods: {
    getComments(loadingMore = false) {
      this.$store.dispatch('comment/GET_COMMENTS', { materialId: this.materialId, loadingMore });
    },
    getHighlightedComments(loadingMore = false) {
      this.$store.dispatch('comment/GET_HIGHLIGHTED_COMMENTS', { materialId: this.materialId, loadingMore });
    },
    countTotalItems() {
      let total;
      if (this.totalItems && this.postedComments.length) {
        total = this.totalItems + this.postedComments.length;
      }
      if (this.totalItems && !this.postedComments.length) {
        total = this.totalItems;
      }
      if (this.highlightedCommentsTotalItems) {
        total += this.highlightedCommentsTotalItems;
      }
      return total;
    },
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  destroyed() {
    this.$store.dispatch('comment/RESET_STATE');
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/common.scss';
.comments-section {
  .comment-count {
    position: relative;
    display: inline-flex;
    justify-content: center;
    .count {
      position: absolute;
      font-size: 14px;
      font-weight: bold;
      margin-top: 5px;
    }
  }
  .load-more {
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin-top: 30px;
    margin-bottom: 30px;
    p {
      @extend .text-sm;
      display: flex;
      align-items: center;
      color: #787878;
      text-transform: lowercase;
      width: 100%;
      text-align: center;
      margin-bottom: 0;
      position: relative;
      span {
        width: 40%;
        padding: 0 5px;
      }
      &::before,
      &::after {
        content: '';
        width: 100%;
        height: 1px;
        background-color: #d5d5d5;
        @include media-breakpoint-down(sm) {
          width: 40%;
        }
      }
    }
  }
  .load-more p {
    text-transform: capitalize;
  }
}
</style>
